module.exports = __webpack_public_path__ + "static/media/step-mobile-3.b15b1f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-mobile-3.png
// module id = 2216
// module chunks = 0